import styled from "@emotion/styled";
import { Card, Typography } from "@mui/material";
import LineItemGrid from "components/Common/LineItemGrid/LineItemGrid";

export const EstimatedSubtotalContainer = styled.div({
	display: "flex",
	flexDirection: "column",
	gap: 8
});

export const EstimatedSubtotalInnerContainer = styled.div(({ theme }) => ({
	display: "flex",
	flexDirection: "row",
	gap: 20,
	justifyContent: "flex-end",
	[theme.breakpoints.down("md")]: {
		gap: "unset",
		justifyContent: "space-between"
	}
}));

export const EstimatedSubtotalCard = styled(Card)(({ theme }) => ({
	alignItems: "flex-end",
	backgroundColor: theme.project.colors.allColors.hex.blue.light.lightBlue50,
	borderRadius: "unset",
	color: theme.project.colors.primaryColors.main,
	display: "flex",
	flexDirection: "column",
	fontSize: 20,
	fontWeight: 400,
	padding: "16px",
	[theme.breakpoints.down("md")]: {
		alignItems: "unset"
	}
}));

export const EstimatedSubtotalTextBold = styled.div({
	fontWeight: 500
});

export const EstimatedSubtotalTextSmall = styled.div({
	fontSize: 14
});

export const AccountBillToCardContainer = styled.div(({ theme }) => ({
	display: "grid",
	columnGap: "16px",
	padding: "16px",
	gridTemplateColumns: "1fr 1fr",
	[theme.breakpoints.down("md")]: {
		gridTemplateColumns: "1fr",
		rowGap: "16px"
	}
}));

export const AccountBillToCard = styled.div(({ theme }) => ({
	border: "solid",
	borderWidth: "1px",
	borderColor: "#0000001f",
	padding: "16px",
	p: {
		...theme.project.typography.body.body2,
		margin: 0,
		gap: 24
	}
}));

export const AccountBillToCardHeader = styled.h1(({ theme }) => ({
	...theme.project.typography.subtitle.subtitle1,
	color: theme.project.colors.fontColors.secondary,
	textTransform: "uppercase",
	marginTop: 0
}));

export const AccountBillToCardDetailsContainer = styled(Typography)({
	display: "flex",
	flexDirection: "row",
	justifyContent: "space-between",
	alignItems: "center",

	"div:nth-of-type(1)": {
		display: "flex",
		flexDirection: "column"
	}
});

export const AccountBillToCardDetails = styled(Typography)({
	flexDirection: "column"
});

export const TotalPriceContainer = styled.div(({ theme }) => ({
	display: "flex",
	justifyContent: "flex-end",
	gap: 16,
	marginTop: 8,
	paddingRight: 16,
	alignItems: "center",
	p: {
		"&:first-child": {
			...theme.project.typography.subtitle.subtitle2,
			margin: 0,
			fontSize: 16,
			color: theme.project.colors.fontColors.main
		},
		"&:nth-child(2)": {
			...theme.project.typography.body.body1,
			color: theme.project.colors.fontColors.main,
			margin: 0
		}
	}
}));

export const EstimatesLineItemGrid = styled(LineItemGrid)({
	"& > div:first-of-type > div:first-of-type": {
		gridColumn: "span 3"
	}
});

export const PriceEstimateGroupedContent = styled.div({
	padding: "0 16px 16px 16px"
});

export const PriceEstimateConfigurations = styled.div({
	marginBottom: 16,
	"& > div": {
		margin: "8px 0"
	}
});

export const LineItemCount = styled.div(({ theme }) => ({
	...theme.project.typography.overline,
	color: theme.project.colors.fontColors.main,
	display: "flex",
	justifyContent: "flex-end",
	[theme.breakpoints.down("md")]: {
		justifyContent: "flex-start",
		marginBottom: 8
	}
}));

export const PriceEstimateCard = styled(Card)({
	marginBottom: 24
});

export const PriceEstimateCardContent = styled.div({
	paddingBottom: 16
});
